import { Box, List, ListItem, ListItemButton, Typography } from '@mui/material'
import { useTranslate } from 'react-admin'

import { useEffect, useState } from 'react'
import { isNil, map } from 'lodash/fp'
import { getCategories } from 'components/Util/functions'

const Categories: React.FC = (): JSX.Element => {
  const translation = useTranslate()
  const [categories, setCategories] = useState<string[] | undefined>(undefined)
  useEffect(() => {
    if (!isNil(categories)) return
    getCategories().then((result: string[] | undefined) => {
      setCategories(result)
    })
  }, [])
  return (
    <>
    <Box component={'img'} src={'/common/img/top_visual.png'}></Box>
    <Box display="grid" justifyContent="center" marginY={5}>
      <Typography
        variant="h4"
        sx={{
          whiteSpace: 'pre-line',
          fontWeight: 700,
          marginBottom: 4
        }}>
        {translation('resources.category.title')}
      </Typography>
      <List
        sx={{
          fontSize: 30,
          fontWeight: 500,
          textAlign: 'center'
        }}>
        {map((category: string) => {
          return (
            <ListItem>
              <ListItemButton href={`/${encodeURIComponent(category)}`}>
                {category}
              </ListItemButton>
            </ListItem>
          )
        })(categories)}
      </List>
    </Box>
    </>
  )
}

export default Categories
